// @ts-check
/* eslint-env browser */

import { reactiveStore } from '../reactive-store.js'
import './status-tag.js'
import './entity-list/entity-list-item.js'
import './entity-list/entity-list.js'
import './entity-list/map-overlay-item.js'

export class TextData extends HTMLElement {
  connectedCallback () {
    reactiveStore.selectedFeatureId.subscribe((/** @type {string} */ id) => {
      this.#selectFeature(id)
    })

    reactiveStore.features.subscribe((_currentFeatures, message) => {
      const selectedId = reactiveStore.selectedFeatureId.get()
      if (selectedId && message !== 'status-complete' && message !== 'no-save') {
        this.#markEntityAsIncomplete(selectedId)
      }

      window.setTimeout(() => {
        this.querySelectorAll('.govuk-tabs__panel').forEach((panel) => {
          if (panel instanceof HTMLElement) {
            this.#updateTabCount(panel)
          }
        })
      }, 0)
    })

    this.querySelectorAll('input, textarea').forEach((el) => {
      el.addEventListener('input', () => {
        this.#markEntityAsIncomplete(el.closest('details')?.dataset.entityId)
      })
    })
  }

  #markEntityAsIncomplete (id) {
    this.querySelector(`[data-entity-id="${id}"] status-tag`)?.setAttribute('data-complete', 'false')
  }

  /**
   * Selects a feature and updates the aria-selected attribute on all features
   * @param {string} id
   */
  #selectFeature (id) {
    /** @type NodeListOf<HTMLDetailsElement> */
    const allFeatures = this.querySelectorAll('[data-entity-id]')
    allFeatures.forEach((feature) => {
      if (!(feature instanceof HTMLElement)) return
      const selected = feature.getAttribute('data-entity-id') === id
      feature.setAttribute('aria-selected', selected ? 'true' : 'false')
      if (selected) {
        // ensure correct tab is selected
        const containerId = feature.closest('.govuk-tabs__panel')?.getAttribute('id')
        /** @type {HTMLElement | null} */
        const tab = this.querySelector(`.govuk-tabs__tab[href="#${containerId}"]`)
        tab?.click()

        // expand feature and scroll into view (only for map clicks, not tab clicks)
        // tab clicks are handled by native details toggle behavior
        if (!document.activeElement?.closest('details')) {
          feature.open = true
          const container = feature.closest('.govuk-tabs__panel') || feature.parentElement
          const scrollOffset = this.querySelector('.govuk-tabs__list')?.scrollHeight || 0
          const summary = feature.querySelector('summary')
          if (summary && container) {
            container.scrollTo({ top: summary.offsetTop - scrollOffset, behavior: 'smooth' })
          }
        }
      }
    })
  }

  /**
   * Updates the count in the tab label for a given panel
   * @param {HTMLElement} panel
   */
  #updateTabCount (panel) {
    const tab = this.querySelector(`.govuk-tabs__tab[href="#${panel.getAttribute('id')}"]`)
    if (!tab) return

    const countSpan = tab.querySelector('.text-data__tab-count')
    if (!countSpan) return

    const count = panel.querySelectorAll('.entity-list li').length
    countSpan.textContent = `(${count})`
  }
}

customElements.define('text-data', TextData)
